module.exports = __webpack_public_path__ + "media/flags/es-942d2dd9.svg";